export const getNumberFontSize = (width: number, fraction?: number): string => {
  const adjustedWidth = width / (fraction ? fraction : 1);

  if (adjustedWidth >= 400) {
    return "xxl";
  }

  if (adjustedWidth >= 270) {
    return "xl";
  }

  if (adjustedWidth >= 190) {
    return "lg";
  }

  if (adjustedWidth >= 160) {
    return "md";
  }

  if (adjustedWidth >= 110) {
    return "sm";
  }

  return "xs";
};